import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { updatePartner } from '@/features/partners/api/update-partner';
import { toast } from '@/shared/hooks/use-toast';

export const useUpdatePartner = () => {
  const { t } = useTranslation('partner', { keyPrefix: 'PartnerHub' });
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updatePartner,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['partners'] });
    },
    onError: (error) => {
      toast({
        title: t('Errors.update'),
        description: error.message,
      });
    },
  });
};
